import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { getElementRef } from '../../utils/getElementRef';
import { composeRefs } from '../../hooks/useComposedRefs';
import { jsx as _jsx } from "react/jsx-runtime";
const SlotClone = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const {
      children
    } = props,
    slotProps = _objectWithoutProperties(props, _excluded);
  if ( /*#__PURE__*/React.isValidElement(children)) {
    const childrenRef = getElementRef(children);
    return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, mergeProps(slotProps, children.props)), {}, {
      // @ts-expect-error `ref` не является допустимым свойством для ReactElement, но используется в `getElementRef`
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = 'SlotClone';
const Slottable = _ref => {
  let {
    children
  } = _ref;
  return children;
};
export const Slot = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const {
      children
    } = props,
    slotProps = _objectWithoutProperties(props, _excluded2);
  const childrenArray = React.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable);
  if (slottable) {
    // новый элемент для рендеринга - это тот, который передан как дочерний элемент `Slottable`
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        // поскольку новый элемент будет рендериться, нас интересуют только его дочерние элементы (`newElement.props.children`)
        if (React.Children.count(newElement) > 1) {
          return React.Children.only(null);
        }
        return /*#__PURE__*/React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /*#__PURE__*/_jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
      ref: forwardedRef,
      children: /*#__PURE__*/React.isValidElement(newElement) ? /*#__PURE__*/React.cloneElement(newElement, undefined, newChildren) : null
    }));
  }
  return /*#__PURE__*/_jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
    ref: forwardedRef,
    children: children
  }));
});
Slot.displayName = 'Slot';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function isSlottable(child) {
  return /*#__PURE__*/React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  // все свойства дочернего элемента должны переопределять
  const overrideProps = _objectSpread({}, childProps);
  for (const propName in childProps) {
    if (Object.prototype.hasOwnProperty.call(childProps, propName)) {
      const slotPropValue = slotProps[propName];
      const childPropValue = childProps[propName];
      const isHandler = /^on[A-Z]/.test(propName);
      if (isHandler) {
        // если обработчик существует в обоих, мы их объединяем
        if (slotPropValue && childPropValue) {
          overrideProps[propName] = function () {
            childPropValue(...arguments);
            slotPropValue(...arguments);
          };
        }
        // но если он существует только в слоте, мы используем только его
        else if (slotPropValue) {
          overrideProps[propName] = slotPropValue;
        }
      }
      // если это `style`, мы их объединяем
      else if (propName === 'style') {
        overrideProps[propName] = _objectSpread(_objectSpread({}, slotPropValue), childPropValue);
      } else if (propName === 'className') {
        overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(' ');
      }
    }
  }
  return _objectSpread(_objectSpread({}, slotProps), overrideProps);
}